import { formatCurrency, formatPercentRaw } from './formatters';

/**
 * Portal theme colours for charts
 */
export const CHART_COLORS = {
  primary: '#072040',
  secondary: '#f0a500',
  light: '#E7E6E6',
  dark: '#212529',
  gray: '#6c757d',
  success: '#91CF9B',
  danger: '#ffc107',
  info: '#599BE3',
  white: '#ffffff',
};

/**
 * Fan chart colours for percentile bands (primary at varying opacities)
 */
export const FAN_CHART_COLORS = {
  outer: 'rgba(89, 155, 227, 0.19)',   // #599BE330 — 10th–25th & 75th–90th bands
  inner: 'rgba(89, 155, 227, 0.31)',   // #599BE350 — 25th–50th & 50th–75th bands
  median: '#599BE3',                    // 50th percentile line
};

/**
 * Income breakdown chart colours
 */
export const INCOME_COLORS = {
  portfolio: '#305496',
  pension: '#FFC000',
  employment: '#808080',
  other: '#011E41',
  rental: '#AA8090',
  annuity: '#91CF9B',
  lumpSum: '#599BE3',
};

/**
 * Default tooltip configuration — brand-styled
 */
export const defaultTooltipConfig = {
  enabled: true,
  mode: 'index',
  intersect: false,
  backgroundColor: '#072040',
  titleColor: '#ffffff',
  bodyColor: 'rgba(255, 255, 255, 0.9)',
  borderColor: 'rgba(240, 165, 0, 0.5)',
  borderWidth: 1,
  padding: 12,
  cornerRadius: 6,
  titleFont: {
    family: "'Calibre', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    size: 13,
    weight: 'bold',
  },
  bodyFont: {
    family: "'Calibre', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    size: 12,
  },
  titleMarginBottom: 8,
  bodySpacing: 4,
};

/**
 * Default grid configuration — very subtle
 */
export const defaultGridConfig = {
  color: 'rgba(0, 51, 102, 0.06)',
  drawBorder: false,
  tickColor: 'transparent',
};

/**
 * Default legend configuration — refined
 */
export const defaultLegendConfig = {
  display: true,
  position: 'top',
  align: 'end',
  labels: {
    usePointStyle: true,
    pointStyle: 'circle',
    boxWidth: 8,
    padding: 16,
    font: {
      family: "'Calibre', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      size: 12,
    },
    color: '#6c757d',
  },
};

/**
 * Default scale title configuration
 */
export const defaultScaleTitleConfig = {
  display: true,
  font: {
    family: "'Calibre', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    size: 12,
    weight: '500',
  },
  color: '#6c757d',
  padding: { top: 4, bottom: 4 },
};

/**
 * Y-axis currency callback for Chart.js scales
 */
export const currencyCallback = (value) => {
  if (Math.abs(value) >= 1000000) {
    return `$${(value / 1000000).toFixed(1)}M`;
  }
  if (Math.abs(value) >= 1000) {
    return `$${(value / 1000).toFixed(0)}K`;
  }
  return `$${value}`;
};

/**
 * Y-axis percentage callback for Chart.js scales
 */
export const percentCallback = (value) => {
  return `${value.toFixed(1)}%`;
};
